import type { RolCodigo } from '../types/database.types';

/**
 * Estas constantes reflejan la matriz de permisos del DAF v2 (sección 5).
 * Solo se usan para decisiones de UI (mostrar/ocultar). La autorización
 * real vive en las políticas RLS de schema.sql — ver ARQUITECTURA_FRONTEND.md
 * sección 1.
 */

export const ROLES = {
  ADMIN: 'admin',
  RECEPCION: 'recepcion',
  PROFESIONAL: 'profesional',
  CLIENTA: 'clienta',
} as const satisfies Record<string, RolCodigo>;

export const ROL_LABELS: Record<RolCodigo, string> = {
  admin: 'Administrador',
  recepcion: 'Recepción',
  profesional: 'Profesional',
  clienta: 'Clienta',
};

export const STAFF_ROLES: RolCodigo[] = [ROLES.ADMIN, ROLES.RECEPCION];

export function isStaff(rol: RolCodigo | null | undefined): boolean {
  return !!rol && STAFF_ROLES.includes(rol);
}

export function isAdmin(rol: RolCodigo | null | undefined): boolean {
  return rol === ROLES.ADMIN;
}
